<template>
  <div>
    <div class="list" v-show="!isShowDetail">
      <!-- 到货异常登记 -->
      <baseBreadcrumb :page="$t('message.abnormalArrivalRegistration')" :menu="$t('message.problemSolving')" />
      <div class="body">
        <div class="search">
          <div class="left">
            <!-- 原入库单号 -->
            <div class="item">
              <el-input v-model="datas.inbound_sn" :placeholder="$t('message.originalInboundOrderNumber')" />
            </div>
            <!-- 客户名/ID -->
            <div class="item">
              <el-input v-model="datas.user_id" :placeholder="$t('message.userNameOrID')" />
            </div>
            <!-- 到仓方式 -->
            <div class="item">
              <el-select v-model="datas.arrive_type" :placeholder="$t('message.arrivalWarehouseMethod')">
                <el-option label="快递包裹" value="快递包裹" />
                <el-option label="箱" value="箱" />
              </el-select>
            </div>
            <!-- 入库类型 -->
            <div class="item">
              <el-select v-model="datas.inbound_type" :placeholder="$t('message.inboundType')">
                <el-option label="一件代发" value="1" />
                <el-option label="备货中转" value="2" />
              </el-select>
            </div>
            <!-- 跟踪单号 -->
            <div class="item">
              <el-input v-model="datas.express_no" :placeholder="$t('message.trackingNumber')" />
            </div>
            <!-- 提出时间 -->
            <div class="item">
              <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
                :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.endTime')" />
            </div>
            <div class="item">
              <!-- 搜索 -->
              <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
              <el-button @click="reset">{{ $t('message.reset') }}</el-button>
            </div>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 配货订单号 -->
            <li>{{ $t('message.assignmentOrderNumber') }}</li>
            <!-- 三方订单号 -->
            <li>{{ $t('message.thirdPartyOrderNumber') }}</li>
            <!-- 海外仓异常单号 -->
            <li class="flex15">{{ $t('message.overseasWarehouseAbnormalOrderNumber') }}</li>
            <!-- 客户名 -->
            <li>{{ $t('message.customerName') }}</li>
            <!-- 产品数量 -->
            <li>{{ $t('message.productQuantity') }}</li>
            <!-- SKU数 -->
            <li>{{ $t('message.numberOfSKUs') }}</li>
            <!-- 箱数 -->
            <li>{{ $t('message.boxNum') }}</li>
            <!-- 到仓方式 -->
            <li>{{ $t('message.arrivalWarehouseMethod') }}</li>
            <!-- 入库类型 -->
            <li>{{ $t('message.inboundType') }}</li>
            <!-- 跟踪单号 -->
            <li>{{ $t('message.trackingNumber') }}</li>
            <!-- 提出时间 -->
            <li>{{ $t('message.proposeTime') }}</li>
            <!-- 状态 -->
            <li>{{ $t('message.status') }}</li>
            <!-- 操作 -->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">
              {{ item.rowNumber }}
            </li>
            <!-- 配货订单号 -->
            <li>
              <a href="javascript:;"> {{ item.inbound_sn }}</a>

            </li>
            <!-- 三方订单号 -->
            <li>
              <a href="javascript:;"> {{ item.inboundRelevance ? item.inboundRelevance.porder_sn : '' }}</a>
            </li>
            <!-- 海外仓异常单号 -->
            <li class="flex15">
              <a href="javascript:;"> {{ item.abnormal_sn }}</a>
            </li>
            <!-- 客户名 -->
            <li>
              <div class="template">
                <p>ID:{{ item.user_id }}</p>
                {{ item.realname }}
              </div>
            </li>
            <!-- 产品数量 -->
            <li>{{ item.product_count }}</li>
            <!-- SKU数 -->
            <li style="color:#B4272D">
              <el-popover placement="bottom" width="532" trigger="click">
                <div class="table">
                  <ol>
                    <li class="flex2">产品名称</li>
                    <li>SKU</li>
                    <li>数量</li>
                  </ol>
                  <ul v-for="(item2, index2) in skuList" :key="index2">
                    <li class="flex2">{{ item2.product_name }}</li>
                    <li>{{ item2.sku }}</li>
                    <li>{{ item2.stock_num }}</li>
                  </ul>
                </div>
                <span slot="reference" @click="abnormalArrivalDetail(item.abnormal_sn)">{{ item.sku_count }}</span>
              </el-popover>
            </li>
            <!-- 箱数 -->
            <li>{{ item.box_count }}</li>
            <!-- 到仓方式 -->
            <li>{{ item.arrive_type }}</li>
            <!-- 入库类型 -->
            <li>{{ item.abnormal_type_name }}</li>
            <!-- 跟踪单号 -->
            <li>{{ item.tracking_no }}</li>
            <!-- 提出时间 -->
            <li>
              <div style="width:80px">{{ item.created_at }}</div>
            </li>
            <!-- 状态 -->
            <li>{{ item.status_name }}</li>
            <!-- 操作 -->
            <li>
              <div class="template">
                <p style="margin-bottom: 10px;" v-if="item.status == 1">
                  <el-button type="primary" size="mini" @click="handle(item.abnormal_sn, false)">处理</el-button>
                </p>
                <p>
                  <el-button type="primary" size="mini" class="primary"
                    @click="handle(item.abnormal_sn, true)">详情</el-button>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 海外仓异常详情 -->
    <detail ref="detail" v-show="isShowDetail"></detail>
  </div>
</template>
<script>
import detail from './components/detail.vue'

export default {
  components: {
    detail
  },
  data() {
    return {
      isShowDetail: false,
      options: [],
      datas: {
        page: 1,
        pageSize: 20,
      },
      time: [],
      total: 0,
      tableData: [],
      skuList: [],
    };
  },
  created() {
    this.abnormalArrivalList()
  },
  methods: {
    abnormalArrivalList() {
      if (this.time.length > 0) {
        this.datas.submit_time_start = this.time[0]
        this.datas.submit_time_end = this.time[1]
      } else {
        this.datas.submit_time_start = ''
        this.datas.submit_time_end = ''
      }
      this.$api.overseasWarehouseApi.abnormalArrivalList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.abnormalArrivalList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        abnormal_sn: '',
        inbound_sn: '',
        inbound_type: '',
        status: '',
        submit_time_start: '',
        submit_time_end: '',
        user_id: '',
        arrive_type: '',
        express_no: '',
      };
      this.time = []
      this.abnormalArrivalList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.abnormalArrivalList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.abnormalArrivalList();
    },
    // 海外仓异常详情
    abnormalArrivalDetail(abnormal_sn) {
      this.skuList = []
      this.$api.overseasWarehouseApi.abnormalArrivalDetail({ abnormal_sn }).then(res => {
        res.data.box_groups.forEach(item => {
          this.skuList = [...this.skuList, ...item.products]
        })

      })
    },
    // 处理/详情
    handle(abnormal_sn, isHandle) {
      this.$refs.detail.isHandle = isHandle
      this.isShowDetail = true
      this.$refs.detail.abnormalArrivalDetail(abnormal_sn)
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
}

.table {
  ol {
    height: 50px;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  ul {
    padding: 20px 0px;
    background-color: #fff;

    li {
      word-break: break-all;

      a {
        color: #B4272D;
        text-decoration: underline;
      }
    }

    .tamplate {
      width: 100%;
      text-align: left;
    }
  }
}
</style>